
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-condition",
      function () {
        return require("private-next-pages/terms-condition/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-condition"])
      });
    }
  